import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

class Action {
    constructor(args) {
        let self = this;
        self._setArgs(args);

        self._init();
    };

    _elems = {
        $_          : $(),
        $activate   : $(),
        $deactivate : $(),
        $remove     : $()
    };

    _args = {
        id           : 0,
        activate     : {},
        deactivate   : {},
        remove       : {},
        confirmation : {},
        done         : {},
        entities     : '',
        entity       : '',
        prefix       : '',
        suffix       : '',
        self         : {}
    };

    _state = {
        activate     : {
            title : null
        },
        deactivate   : {
            title : null
        },
        remove       : {
            title   : 'Удаление'
        },
        confirmation : {
            title : 'это'
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.id           = args.id;
        self._args.activate     = args.actions.activate;
        self._args.deactivate   = args.actions.deactivate;
        self._args.remove       = args.actions.remove;
        self._args.confirmation = args.actions.confirmation;
        self._args.done         = args.actions.done && Object.keys(args.actions.done).length ? args.actions.done : {};
        self._args.entities     = args.entities;
        self._args.entity       = args.entity;
        self._args.prefix       = args.prefix ? args.prefix  + '/' : '';
        self._args.self         = args.self;
    };

    _bindElements = () => {
        let self = this;

        self._elems.$_ = !self._elems.$_.length ? $('.content') : self._elems.$_;
        if(!self._elems.$_.length) return;

        self._elems.$activate   = self._elems.$_.find('.js-profile-activate');
        self._elems.$deactivate = self._elems.$_.find('.js-profile-deactivate');
        self._elems.$remove     = self._elems.$_.find('.js-profile-remove');
    };

    _bindActivate = () => {
        let self = this;
        if (!self._elems.$activate.length) return;

        self._elems.$activate.unbind('click').click(function (e) {
            e.preventDefault();

            if ($(this).data('id')) {
                self._args.id = $(this).data('id');
            }

            const name = $(this).data('name') && $(this).data('name') !== '' ? $(this).data('name') : null;
            if (name && self._args.activate[name]) {
                self._state.activate = self._args.activate[name];
                self._args.suffix = '/' + self._state.activate.entities + '/' + $(this).data('id');
                self._args.id = $(this).data('id');
                self._args.parentId = $(this).data('parent_id') ? $(this).data('parent_id') : 0;
            }

            new Modal({
                title   : self._state.activate.title !== null ? self._state.activate.title : self._args.activate.title,
                content : Utils.renderProfileTemplate('activate-confirmation', {
                    args    : name && self._args.activate[name] && self._state.activate.confirmation && self._state.activate.confirmation.title != null ? self._state.activate : self._args,
                    content : self._state.activate.confirmation && self._state.activate.title !== null ? self._state.activate.content && self._state.activate.content(self._args) : self._args.activate.content && self._args.activate.content(self._args)
                }),
                confirm : function(args) {
                    loader.increase();

                    let $modal = args.modal;
                    if (!$modal.length) return;
                    let $form = $modal.find('form');

                    Request.send({
                        path   : '/api/' + self._args.prefix + self._args.entities + '/' + ( self._args.parentId ? self._args.parentId : self._args.id) + self._args.suffix + '/activate',
                        method : 'POST',
                        data   : $form.length ? $form.serialize() : '',
                        done   : function (response) {
                            loader.decrease();

                            if (response.error) {
                                //self.callback.error(response.error, $form, self);
                                return;
                            }

                            let entity = self._args.entity;
                            if (self._args.entity == 'vk') {
                                entity = 'social';
                            }

                            $modal.trigger('close');
                            if (Object.keys(self._args.done).length && self._args.done.activate) {
                                args[entity] = response[entity];
                                args.self                = self._args.self;
                                self._args.done.activate(args);
                            }
                        }
                    });
                }
            })
        });
    };

    _bindDeactivate = () => {
        let self = this;
        if (!self._elems.$deactivate.length) return;

        self._elems.$deactivate.unbind('click').click(function (e) {
            e.preventDefault();

            if ($(this).data('id')) {
                self._args.id = $(this).data('id');
                self._args.parentId = $(this).data('parent_id') ? $(this).data('parent_id') : 0;
            }

            const name = $(this).data('name') && $(this).data('name') !== '' ? $(this).data('name') : null;
            if(name && self._args.deactivate[name]) {
                self._state.deactivate = self._args.deactivate[name];
                self._args.suffix = '/' + self._state.deactivate.entities + '/' + $(this).data('id');
                self._args.id = $(this).data('id');
                self._args.parentId = $(this).data('parent_id') ? $(this).data('parent_id') : 0;
            }

            new Modal({
                title   : self._state.deactivate.title !== null ? self._state.deactivate.title : self._args.deactivate.title,
                content : Utils.renderProfileTemplate('deactivate-confirmation', {
                    args : name && self._args.activate[name] && self._state.deactivate.confirmation && self._state.deactivate.confirmation.title != null ? self._state.deactivate : self._args
                }),
                confirm : function(args) {
                    loader.increase();

                    let $modal = args.modal;
                    if (!$modal.length) return;

                    Request.send({
                        path   : '/api/' + self._args.prefix + self._args.entities + '/' + ( self._args.parentId ? self._args.parentId : self._args.id) + self._args.suffix + '/deactivate',
                        method : 'POST',
                        done   : function (response) {
                            loader.decrease();

                            if (response.error) {
                                //self.callback.error(response.error, $form, self);
                                return;
                            }

                            let entity = self._args.entity;
                            if (self._args.entity == 'vk') {
                                entity = 'social';
                            }

                            $modal.trigger('close');
                            if (Object.keys(self._args.done).length && self._args.done.deactivate) {
                                args[entity] = response[entity];
                                args.self                = self._args.self;
                                self._args.done.deactivate(args);
                            }
                        }
                    });
                }
            });
        });
    };

    _bindRemove = () => {
        let self = this;
        if (!self._elems.$remove.length) return;

        self._elems.$remove.unbind('click').click(function (e) {
            e.preventDefault();

            const name = $(this).data('name') && $(this).data('name') !== '' ? $(this).data('name') : null;
            if (name && self._args.remove[name]) {
                self._state.remove = self._args.remove[name];
                self._args.suffix = '/' + self._state.remove.entities + '/' + $(this).data('id');
                self._args.id = $(this).data('id');
                self._args.parentId = $(this).data('parent_id') ? $(this).data('parent_id') : 0;
            }

            if ($(this).data('id')) {
                self._args.id = $(this).data('id');
            }

            let removeDone = function(){
                new Modal({
                    title   : self._state.remove.title !== null ? self._state.remove.title : self._args.remove.title,
                    content : Utils.renderProfileTemplate('removing-confirmation', {
                        args : name && self._args.remove[name] && self._state.remove.confirmation && self._state.remove.confirmation.title != null ? self._state.remove : self._args
                    }),
                    confirm : function(args) {
                        loader.increase();

                        let $modal = args.modal;
                        if (!$modal.length) return;

                        Request.send({
                            path   : '/api/' + self._args.prefix + self._args.entities + '/' + ( self._args.parentId ? self._args.parentId : self._args.id) + self._args.suffix + '/remove',
                            method : 'POST',
                            done   : function (response) {
                                loader.decrease();

                                if (response.error) {
                                    //self.callback.error(response.error, $form, self);
                                    return;
                                }

                                let entity = self._args.entity;
                                if (self._args.entity == 'vk') {
                                    entity = 'social';
                                }

                                $modal.trigger('close');
                                if(Object.keys(self._args.done).length && self._args.done.remove && self._args.done.remove[name]) {
                                    if (response[entity]) {
                                        args[entity] = response[entity];
                                    }
                                    args.self    = self._args.self;
                                    self._args.done.remove[name](args);
                                }
                                else if(Object.keys(self._args.done).length && self._args.done.remove && typeof self._args.done.remove === 'function') {
                                    args.name = name;
                                    args[entity] = response[entity];
                                    args.self    = self._args.self;
                                    self._args.done.remove(args);
                                } else {
                                    window.location.href = '/profile#' + (self._args.prefix != '' ? self._args.prefix.substring(0, self._args.prefix.length - 1) : self._args.entities);
                                }
                            }
                        });
                    }
                });
            };

            if(self._args.remove.before !== undefined) {
                self._args.remove.before({
                    done     : removeDone,
                    entities : self._args.entities,
                    entity   : self._args.entity,
                    id       : self._args.id
                });
                return;
            }

            removeDone();
        });
    };

    _submitDeactivate = () => {

    };

    _bindUI = () => {
        let self = this;

        self._bindActivate();
        self._bindDeactivate();
        self._bindRemove();
    };

    _init = () => {
        let self = this;

        self._bindElements();
        self._bindUI();
    }
}

export default Action;

